import pages from "./pages";
import dashboard from "./dashboard";
import utilities from "./utilities";
import logistics from "./logistics";
import support from "./support";
import accordion from "./accordion";
import order from "./order";
import sample from "./sample";
import reports from "./reports";
import production from "./production";
import humanResources from "./humanResources";
import finance from "./finance";

const menuItems = {
  items: [dashboard, pages, accordion, sample, order, logistics, production, utilities, reports, finance, humanResources, support],
};

export default menuItems;
